module.exports = __webpack_public_path__ + "static/media/plan-B8-desktop-sc.ea5c8ff8.png";